$(document).ready(function(){

    var loadMoreProducts = true, 
        page = 2;

        /* Dom Elements */
    var contentWin = $(window),
        /* Products List */
        referenceElement = $('footer'),
        productsListContainer = $('#list-product-content'),
        postType = productsListContainer.data('type'),
        postDisplay = productsListContainer.data('display'),
        /* Read More Button */
        readMoreButton = $('.read-more-btn'),
        readMoreSection = readMoreButton.closest( ".read-more-section" ),
        readMoreContent = $('.read-more-content'),
        readMoreDisplayedClass = 'read-more-displayed',
        /*load more button */
        loadMoreBtn = $(".load-more-products-btn"),
        /*FAQ page links*/
        faqPageLinks = $(".page-faq .main-content a");


    //contentWin.scroll(function() {
    loadMoreBtn.click(function(e){
        e.preventDefault();
        if(referenceElement.nearVisible(500)){
            if(loadMoreProducts){
                $.ajax({
                    type: 'post',
                    url: '/wp-admin/admin-ajax.php',
                    data: {
                        action: 'productsajax',
                        posttype: postType,
                        display: postDisplay,
                        numpage: page++
                    },
                    success: function(result){
                        var html = result.slice(0, -1),
                            cards = $(html).find(".card").length;
                        loadMoreProducts = !(cards < 6);
                        productsListContainer.append(html);
                        if(!loadMoreProducts){
                            loadMoreBtn.fadeOut();
                        }
                    }
                });
            }
        }
    });

    readMoreButton.click(function(event){
        event.preventDefault();
        if(readMoreContent.hasClass(readMoreDisplayedClass)){
            yebalok.scrollTo(readMoreSection);
        }
        readMoreContent.slideToggle('slow', function(){
            if(readMoreContent.is(':visible')){
                readMoreButton.html('Read Less');
                readMoreContent.addClass(readMoreDisplayedClass);
            } else {
                readMoreButton.html('Read More');
                readMoreContent.remove(readMoreDisplayedClass);
            }
        });
    });

    faqPageLinks.click(function(event){
        event.preventDefault();
        yebalok.scrollToOffset($($(this).attr("href")), 120);
    });
});


// WEBPACK FOOTER //
// ./js/partials/content.js